import * as types from "./types";
import { 
    getTenantListAxios, 
    activateTenantAxios,
    postTenantAxios,
    putTenantAxios,
    putTenantDetailsAxios,
    deactivateTenantAxios,
    getTenantByIdAxios,
    getTenantFCByModuleAxios,putTenantFCAxios,
    putModuleConfigAxios, getUserLogsAxios,
    postSignatureAxios, getSignatureIDAxios
} from "./services";

export async function getTenantListAction({commit}) {
    commit(types.LOADING_TENANT, true);
    try {
        const {data} = await getTenantListAxios();
        commit(types.GET_TENANT_LIST, data.result);
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    finally
    {
        commit(types.LOADING_TENANT, false);
    }
}

export async function getTenantIdAction({commit}, payload) {
    commit(types.LOADING_TENANT, true);
    try {
        const {data} = await getTenantByIdAxios(payload);
        commit(types.GET_TENANT_ID, data.result);
    }
    catch(e) {
        throw e;
    }
    finally
    {
        commit(types.LOADING_TENANT, false);
    }
}

export async function getTenantFCByModuleAction({commit}, payload) {
    commit(types.LOADING_TENANT, true);
    try {
        const {data} = await getTenantFCByModuleAxios(payload);
        commit(types.GET_TENANT_FIELDS, data.result);
    }
    catch(e) {
        throw e;
    }
    finally
    {
        commit(types.LOADING_TENANT, false);
    }
}

export async function activateTenantAction({commit},payload) {
    commit(types.LOADING_TENANT, true);
    try {
        await activateTenantAxios(payload);
       
    }
    catch(e) {
        throw e;
    }
    finally
    {
        commit(types.LOADING_TENANT, false);
    }
}

export async function deactivateTenantAction({commit},payload) {
    commit(types.LOADING_TENANT, true);
    try {
        await deactivateTenantAxios(payload);
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    finally
    {
        commit(types.LOADING_TENANT, false);
    }
}

export async function addTenantAction({commit}, payload) {
    commit(types.LOADING_TENANT, true);
    try {
        await postTenantAxios(payload);
        commit(types.ADD_TENANT, payload);
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    finally
    {
        commit(types.LOADING_TENANT, false);
    }
}

export async function updateTenantAction({commit}, payload) {
    commit(types.LOADING_TENANT, true);
    try {
        await putTenantAxios(payload);        
        commit(types.UPDATE_TENANT, payload);
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    finally
    {
        commit(types.LOADING_TENANT, false);
    }
}

export async function updateTenantDetailsAction({commit}, payload) {
    commit(types.LOADING_TENANT, true);
    try {
        await putTenantDetailsAxios(payload);        
        commit(types.UPDATE_TENANT_DETAILS, payload);
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    finally
    {
        commit(types.LOADING_TENANT, false);
    }
}

export async function updateTenantFCAction({commit}, payload) {
    commit(types.LOADING_TENANT, true);
    try {
        await putTenantFCAxios(payload);        
        commit(types.UPDATE_TENANT_FIELDS, payload);
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    finally
    {
        commit(types.LOADING_TENANT, false);
    }
}

export async function getUserLogsAction({commit}, {TableName, PrimaryKey}) {
    commit(types.LOADING_LOGS, true);
    try {
        console.log("tname", TableName);
        console.log("pkey", PrimaryKey);
        const {data} = await getUserLogsAxios(TableName, PrimaryKey);
        commit(types.GET_USER_LOGS, data);
        console.log("logssssssssss", data);
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    finally
    {
        commit(types.LOADING_LOGS, false);
    }
}

export async function updateModuleConfigAction({commit}, payload) {
    commit(types.LOADING_MODULE, true);
    try {
        await putModuleConfigAxios(payload);        
        commit(types.UPDATE_MODULE_CONFIG, payload);
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    finally
    {
        commit(types.LOADING_MODULE, false);
    }
}

export async function addSignatureAction({commit}, payload) {
    commit(types.LOADING_MODULE, true);
    try {
        const {data} = await postSignatureAxios(payload);
        payload.id = data.result.id;
        commit(types.ADD_SIGNATURE, payload);
        return data;
    }
    catch(e) {
        console.log(e);
    }
    finally {
        commit(types.LOADING_MODULE, false);
    }
}

export async function getSignatureByIDAction({commit},{moduletype, id}) {
    console.log("🚀 ~ getSignatureByIDAction ~ id:", id)
    console.log("🚀 ~ getSignatureByIDAction ~ moduletype:", moduletype)
    commit(types.LOADING_MODULE, true);
    try {
        const {data} = await getSignatureIDAxios(moduletype,id);
        commit(types.GET_SIGNATURE_BYID, data.result);
        return data.result;
    }
    catch(e) {
        console.log(e);
        commit(types.GET_SIGNATURE_BYID, []);
    }
    commit(types.LOADING_MODULE, false);
}